import { ItemTypeEnum } from 'libs/gb-dashboard/item/data-access/src/lib/+state/items.models'

export interface RaffleItemsEntity {
  auction: string
  automatic_draw_enabled: boolean | null
  closed: boolean
  closed_status_timestamp: string | null
  closed_timestamp: Date | undefined | null
  drawing_status_timestamp: string | null
  hide_raffle_winners: boolean
  item: string
  item_type: ItemTypeEnum
  max_tickets_per_person: number
  open_status_timestamp: string | null
  paused_status_timestamp: string | null
  pay_now: boolean
  prizes_available: number
  raffle_draws: string[]
  scheduled_draw: string | null
  scheduled_open: string | null
  show_number_of_tickets_available: boolean
  ticket_packages: TicketPackageEntity[]
  ticket_price: number
  tickets_available: number
  tickets_remaining: number
  uuid: string
  raffle_status: RaffleStatusEnum
  tickets_count: number
}

export interface RaffleDrawsEntity {
  auction: string
  initiator: number
  item: string
  prize: number
  profile: string
  profile_display_anonymous: boolean
  profile_name: string
  raffle_item: string
  raffle_ticket: string
  ticket_number: number
  uuid: string
}

export interface TicketPackageEntity {
  order: number
  price: number
  tickets: number
  uuid: string
}

export interface RafflePackage {
  tickets: number
  price: number
}

export enum RaffleStatusEnum {
  Paused = 'paused',
  Open = 'open',
  Drawing = 'drawing',
  Closed = 'closed',
}
